var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.642 16.244C18.041 14.3 19 12.164 19 10a7 7 0 1 0-14 0c0 2.163.958 4.3 2.358 6.244 1.39 1.93 3.1 3.506 4.319 4.505.2.163.446.163.646 0 1.219-.999 2.928-2.575 4.319-4.505Zm-3.052 6.052C16.175 20.179 21 15.492 21 10a9 9 0 1 0-18 0c0 5.492 4.825 10.18 7.41 12.296a2.485 2.485 0 0 0 3.18 0Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
    fill: "#777E91"
  })));
};
export default SvgLine;